import React, { useState, useRef, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'

import { toast } from 'react-toastify'

import api from 'api/api'
import './informacionesSector.css'
import { debounce } from 'utils/debounce'
import Paginacion from 'components/Paginacion'
import NuevaInformacion from './NuevaInformacion'
import DeleteInformacion from './DeleteInformacion'
import VerInformacion from './VerInformacion'
import EditarInformacion from './EditarInformacion'
import { getFileData } from 'utils/general'

function InformacionesSector() {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(10)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [informaciones, setInformaciones] = useState([])
	const [informacionActual, setInformacionActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')

	const refreshInformaciones = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-informaciones-sector', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					nombre: [filtroBusqueda]
				}
			})

			setInformaciones(datos.informaciones)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshInformaciones()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshInformaciones()
		}
	}, [paginaAct])

	const opcionesCuantosMostrar = [10, 25, 50]

	const handleAction = (informacion, cual) => {
		setInformacionActual(informacion, setQueMostrar(cual))
	}

	const subirArchivo = async (archivo) => {
		// Primero sube el archivo, luego crea la información
		const serverData = new FormData();
		serverData.append('foto', archivo)
		let multimediaId = null

		try {
			const { datos, msg } = await api.post('a/multimedia', serverData)
			multimediaId = datos.id
		} catch (error) {
			toast.error('Error ')
		}

		return multimediaId
	}

	const nuevaInformacion = async (data) => {
		const enviar = { ...data }
		if (data.imagen) {
			enviar.multimediaId = await subirArchivo(data.imagen)
		}
		delete enviar.imagen

		try {
			const { msg } = await api.post('a/informaciones-sector', enviar)
			refreshInformaciones()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const editarInformacion = async (data) => {
		const enviar = { ...data }
		if (data.imagen) {
			enviar.multimediaId = await subirArchivo(data.imagen)
		}
		delete enviar.imagen

		try {
			const { msg } = await api.put('a/informaciones-sector/' + data.id, enviar)
			refreshInformaciones()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		}
	}

	const eliminarInformacion = async (id) => {
		const { msg } = await api.delete('a/informaciones-sector/' + id)
		refreshInformaciones()
		setQueMostrar('')
		toast.success(msg)
	}

	// render
	return (
		<Container fluid id="informaciones-sector" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Información del sector</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group className="mb-3" style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">informaciones</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="d-flex no-gutters justify-content-between align-items-end mt-2">
				<Col>
					<Button onClick={() => setQueMostrar('nueva')} variant="primary">
						<i className="fa fa-plus"></i> Nueva información
					</Button>
				</Col>
				<Col className="text-end">
					<small>Total resultados: <strong>{numResultados}</strong></small>
				</Col>
			</Row>
			{/* Table */}
			<Row>
				<Col>
					<Table id="tabla-informaciones" className="mt-2" bordered hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Imagen</th>
								<th>Título</th>
								<th>Orden</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan="6">
										<Spinner
											animation="border"
											size="lg"
											role="status"
											aria-hidden="true"
											variant="primary"
											className="my-3"
										/>
									</td>
								</tr>
							) : (
								informaciones.length === 0 ? (
									<tr>
										<td colSpan="6">
											<Alert variant="info">No se encontraron informaciones</Alert>
										</td>
									</tr>
								) : (
									informaciones.map((informacion, index) => {
										const fileData = getFileData(informacion.multimedia?.url)

										let documentoJsx = <i className={fileData.icono}></i>
										switch (fileData.extension) {
											case 'jpg':
											case 'jpeg':
											case 'png':
											case 'gif':
												documentoJsx = <img src={informacion.multimedia ? process.env.REACT_APP_API_URL + 'uploads/' + informacion.multimedia.url : 'logo192.jpg'} alt={informacion.titulo} />
												break
										}

										return (
											<tr key={informacion.id}>
												<td>{informacion.id}</td>
												<td style={{ textAlign: 'center' }}>{documentoJsx}</td>
												<td>{informacion.titulo}</td>
												<td>{informacion.orden}</td>
												<td>
													<Button
														onClick={() => handleAction(informacion, 'ver')}
														className="me-2"
														variant="primary"
													>
														<i className="fa fa-eye"></i>
													</Button>
													<Button
														onClick={() => handleAction(informacion, 'editar')}
														className="me-2"
														variant="secondary"
													>
														<i className="fa fa-pencil"></i>
													</Button>
													<Button
														onClick={() => handleAction(informacion, 'eliminar')}
														variant="danger"
													>
														<i className="fa fa-trash"></i>
													</Button>
												</td>
											</tr>
										)
									})
								)
							)}
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paginacion
						pagina={paginaAct}
						numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
						setPagina={setPaginaAct}
					/>
				</Col>
			</Row>
			{/* Panel Nuevo */}
			{queMostrar === 'nueva' && (
				<NuevaInformacion
					guardar={nuevaInformacion}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{informacionActual && queMostrar === 'ver' &&
				<VerInformacion
					informacion={informacionActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{informacionActual && queMostrar === 'editar' &&
				<EditarInformacion
					informacionOriginal={informacionActual}
					setQueMostrar={setQueMostrar}
					guardar={editarInformacion}
				/>
			}
			{/* Modal Delete */}
			{
				informacionActual &&
				<DeleteInformacion
					informacion={informacionActual}
					mostrar={queMostrar === 'eliminar'}
					setQueMostrar={setQueMostrar}
					eliminarInformacion={eliminarInformacion}
				/>
			}
		</Container>
	)
}

export default InformacionesSector